module.exports = __webpack_public_path__ + "static/media/Heart.f0eb527b.svg";